export enum UiStatesEnum {
  state = 'state',
  avatarUrl = 'avatarUrl',
  characterName = 'characterName',
  isOffline = 'isOffline',
  chatId = 'chatId',
}
